import { render } from "./AddOrEditWorkTimer.vue?vue&type=template&id=2542a440"
import script from "./AddOrEditWorkTimer.vue?vue&type=script&lang=js"
export * from "./AddOrEditWorkTimer.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__